import { render, staticRenderFns } from "./HandCut.vue?vue&type=template&id=27fd8aa9&scoped=true&"
import script from "./HandCut.vue?vue&type=script&lang=js&"
export * from "./HandCut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd8aa9",
  null
  
)

export default component.exports